import { defineMessages } from 'react-intl';

export const MapStepContent = defineMessages({
  gps: {
    id: 'app.common.gps',
    defaultMessage: 'Souřadnice',
  },
  lat: {
    id: 'app.common.lat',
    defaultMessage: 'Zeměpisná šířka',
  },
  lng: {
    id: 'app.common.lng',
    defaultMessage: 'Zeměpisná délka',
  },
  geolocationNotAllowed: {
    id: 'app.MapStepContent.geolocationNotAllowed',
    defaultMessage: 'Geolokace neni povolená',
  },
});

export const MapStepFooter = defineMessages({
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
  confirmLocation: {
    id: 'app.MapStepFooter.confirmLocation',
    defaultMessage: 'Potvrdit polohu',
  },
});
